// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .fallback-dialog {
        padding: 1.5rem;
        max-width: 440px;
        text-align: left;
      }
      .fallback-title {
        margin: 0 0 0.75rem;
        font-size: 1.2rem;
        font-weight: 700;
        color: #111827;
      }
      .fallback-message,
      .fallback-hint {
        margin: 0 0 0.85rem;
        color: #374151;
        line-height: 1.5;
      }
      .fallback-hint {
        color: #6b7280;
        font-size: 0.9rem;
      }
      .fallback-actions {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 0.75rem;
        margin-top: 1.25rem;
      }
      .btn-primary,
      .btn-secondary {
        border: none;
        border-radius: 8px;
        padding: 0.625rem 1rem;
        font-weight: 600;
        cursor: pointer;
      }
      .btn-primary {
        background: #5ea1d8;
        color: #fff;
      }
      .btn-secondary {
        background: #f3f4f6;
        color: #374151;
      }
    `, "",{"version":3,"sources":["webpack://./src/app/pages/quick-create-flow/pieces-ai-manual-fallback-dialog.component.ts"],"names":[],"mappings":";MACM;QACE,eAAe;QACf,gBAAgB;QAChB,gBAAgB;MAClB;MACA;QACE,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;MAChB;MACA;;QAEE,mBAAmB;QACnB,cAAc;QACd,gBAAgB;MAClB;MACA;QACE,cAAc;QACd,iBAAiB;MACnB;MACA;QACE,aAAa;QACb,yBAAyB;QACzB,eAAe;QACf,YAAY;QACZ,mBAAmB;MACrB;MACA;;QAEE,YAAY;QACZ,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;QAChB,eAAe;MACjB;MACA;QACE,mBAAmB;QACnB,WAAW;MACb;MACA;QACE,mBAAmB;QACnB,cAAc;MAChB","sourcesContent":["\n      .fallback-dialog {\n        padding: 1.5rem;\n        max-width: 440px;\n        text-align: left;\n      }\n      .fallback-title {\n        margin: 0 0 0.75rem;\n        font-size: 1.2rem;\n        font-weight: 700;\n        color: #111827;\n      }\n      .fallback-message,\n      .fallback-hint {\n        margin: 0 0 0.85rem;\n        color: #374151;\n        line-height: 1.5;\n      }\n      .fallback-hint {\n        color: #6b7280;\n        font-size: 0.9rem;\n      }\n      .fallback-actions {\n        display: flex;\n        justify-content: flex-end;\n        flex-wrap: wrap;\n        gap: 0.75rem;\n        margin-top: 1.25rem;\n      }\n      .btn-primary,\n      .btn-secondary {\n        border: none;\n        border-radius: 8px;\n        padding: 0.625rem 1rem;\n        font-weight: 600;\n        cursor: pointer;\n      }\n      .btn-primary {\n        background: #5ea1d8;\n        color: #fff;\n      }\n      .btn-secondary {\n        background: #f3f4f6;\n        color: #374151;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
